export default "__VITE_ASSET__BATHLXSq__"